module.exports = __webpack_public_path__ + "img/close-success.169cb876.svg";